import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import { TranslatedString } from "@classdojo/web/pods/i18n/translate";
import connect from "@classdojo/web/utils/hoc/connect";
import React from "react";
import Modal from "react-modal";
import AppRemoteCard from "./AppRemoteCard";
import CastControl from "src/pods/realtime/components/CastControl";

const mapStateToProps = {};
const connector = connect(mapStateToProps);

type AppModalProps = {
  onRequestStart?: VoidFunction;
  onRequestStop?: VoidFunction;
  onRequestHide?: VoidFunction;
  overlayStyle?: ThemeUIStyleObject;
  headerIconStyle?: ThemeUIStyleObject;
  className?: string;
  title?: TranslatedString;
  icon?: string;
  backgroundColor?: string;
};

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
export default class AppModal extends React.Component<React.PropsWithChildren<AppModalProps>> {
  static wrap(
    AppComponent: React.ComponentClass & {
      appMetadata: { title: TranslatedString; icon: string; backgroundColor: string };
    },
  ) {
    const { title, icon, backgroundColor } = AppComponent.appMetadata || {};

    return connector(
      Object.assign(function AppModalWrapper(props: Record<string, unknown>) {
        return (
          <AppModal title={title} icon={icon} backgroundColor={backgroundColor}>
            <AppComponent {...props} />
          </AppModal>
        );
      }, AppComponent),
    );
  }

  render() {
    const hasCastControl = this.props.onRequestStart && this.props.onRequestStop;
    const props = {
      ...this.props,
      overlayStyle: { ...overlayStyle, ...this.props.overlayStyle },
      style: {
        ...(hasCastControl ? castControlModalStyle : modalStyle),
      },
    };

    return (
      <Modal
        data-name="app_modal:render:modal"
        isOpen
        // eslint-disable-next-line @web-monorepo/no-style-prop
        style={{
          content: {
            border: "none",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            padding: 0,
          },
        }}
      >
        {hasCastControl && (
          <CastControl
            sx={{
              height: "48px",
              lineHeight: "48px",
            }}
            onRequestStart={props.onRequestStart}
            onRequestStop={props.onRequestStop}
          />
        )}
        <AppRemoteCard {...this.props} sx={{ margin: RAW_cssValue(20) }} />
      </Modal>
    );
  }
}

const overlayStyle: ThemeUIStyleObject = {
  backgroundColor: "dt_background_primary",
  overflowY: "auto",
};

const modalStyle: ThemeUIStyleObject = {
  position: "initial",
  maxWidth: "94%",
  marginX: "auto",
  marginY: "dt_s",
  transform: "none",
  WebkitTransform: "none",
  msTransform: "none",
};

const castControlModalStyle: ThemeUIStyleObject = {
  ...modalStyle,
  marginTop: RAW_cssValue("60px"),
};
